import {Component, OnInit, ViewChild} from '@angular/core';
import {IonSlides} from '@ionic/angular';
import {AdminService} from '../../../service/admin.service';

@Component({
  selector: 'app-advertising',
  templateUrl: './advertising.page.html',
  styleUrls: ['./advertising.page.scss'],
})
export class AdvertisingPage implements OnInit {
  @ViewChild('slider', {static: true}) private slider: IonSlides;
  images: any[];
  slideOptions = {
    initialSlide: 0,
    speed: 400,
    autoplay: {
      delay: 3000
    },
  }


  constructor(private adminService: AdminService) {

  }

  ngOnInit() {
    this.images = [];
    console.log(this.images);
    this.loadImages();
    this.startAutoPlay().then();
  }


  public async ionSlideDidChange(): Promise<void> {
    const index = await this.slider.getActiveIndex();
  }

  async startAutoPlay() {
    await this.slider.startAutoplay();
  }

  

  loadImages() {
    this.adminService.getAdvertisements(true).subscribe((res: any[]) => {
        this.images = res.map(i => ({src: i.url}));
      }
    );
  }
}
